<template>
<div class="option-container">
    <label
      class="question-option"
      @click="focusThis"
      v-for="(item,i) in dataList"
      :class="{
        'active':selectedValues[i],
        'is-right-answer':rightValues[i],
        'is-answered-wrong':submitted&&rightAnswer&&!rightValues[i]&&answeredValues[i],
        }"
      :key="i">
        <v-checkbox
          class="option"
          v-model="selectedValues[i]"
          @input="changeSubAnswer($event, i)"
          >
        </v-checkbox>
        <div class="option-desp" v-html="item.text"></div>
        <ct-icon name="check" class="active-right-icon"></ct-icon>
        <ct-icon name="guanbi" class="active-wrong-icon"></ct-icon>
    </label>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { powValues, LETTERS, convertBinarys } from '@/utils/question'
import Checkbox from './Checkbox'

export default {
  name: 'SubQuestionDuoxuan',
  components: {
    'v-checkbox': Checkbox
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    rightAnswer: String,
    userAnswer: {
      type: Object,
      required: true,
      default: () => {
        return {
          answer: '',
          answered: 0,
          is_right: 0,
          question_id: null,
          question_index: 0
        }
      }
    },
    isActive: Boolean,
    subId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      letters: LETTERS,
      selectedValues: []
    }
  },
  watch: {
    answeredValues (value) {
      this.selectedValues = [...value]
    },
    selectedValues (value) {
      this.changeSubAnswer()
    }
  },
  computed: {
    ...mapGetters(['submitted']),
    dataList () {
      let res = this.options.map((item, i) => {
        return {
          text: item,
          value: powValues[i]
        }
      })
      return res
    },
    answeredValues () {
      let answeredValues = []
      answeredValues.length = this.options.length
      for (let i = 0; i < this.options.length; i++) {
        const answered = this.isAnswered(i)
        answeredValues[i] = answered
      }
      return answeredValues
    },
    rightValues () {
      let rightValues = []
      rightValues.length = this.options.length
      for (let i = 0; i < this.options.length; i++) {
        const isRightAnswer = this.isRightAnswer(i)
        rightValues[i] = isRightAnswer
      }
      return rightValues
    }
  },
  mounted () {
    const selectedValues = this.selectedValues
    for (let i = 0; i < this.options.length; i++) {
      const answered = this.isAnswered(i)
      selectedValues[i] = answered
    }
    this.selectedValues = [...selectedValues]
    this.addEvent()
  },
  methods: {
    ...mapActions(['updateSubAnswer']),
    focusThis () {
      this.$emit('focus-subquestion', this.subId)
    },
    getAnwers () {
      let sum = 0
      for (let i = 0; i < this.selectedValues.length; i++) {
        if (this.selectedValues[i]) {
          sum = sum + powValues[i]
        }
      }
      if (sum) {
        return sum
      } else {
        return ''
      }
    },
    changeSubAnswer () {
      const answer = this.getAnwers()
      this.updateSubAnswer({
        index: this.subId, answer: answer
      })
    },
    isRightAnswer (i) {
      if (this.submitted && this.rightAnswer) {
        let answer = this.rightAnswer
        if (!isNaN(this.rightAnswer)) {
          answer = convertBinarys(this.rightAnswer)
        }
        if (answer.includes(this.letters[i])) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    isAnswered (i) {
      // 包括用户缓存和提交答案
      if (this.userAnswer && this.userAnswer.answer > 0) {
        const answer = convertBinarys(this.userAnswer.answer)
        if (answer.includes(this.letters[i])) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    addEvent () {
      if (document.addEventListener) {
        document.addEventListener('keyup', this.handleKeyup)
      }
    },
    handleKeyup (event) {
      if (document.body.style.overflow === 'hidden') {
        return false
      }
      const isLetter = event.keyCode >= 65 && event.keyCode <= 90
      const answerIndex = event.keyCode - 65
      if (this.isActive && isLetter && (answerIndex < this.options.length)) {
        const values = this.selectedValues
        values[answerIndex] = !values[answerIndex]
        this.selectedValues = [...values]
      }
    },
    removeEvent () {
      if (document.removeEventListener) {
        document.removeEventListener('keyup', this.handleKeyup)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './question_option.scss';
</style>
